import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Users } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import ROUTES from '@/routes/routes'

interface ViewPlayerLimitsCardProps {
  roomId: string
}

export function ViewPlayerLimitsCard({ roomId }: ViewPlayerLimitsCardProps) {
  return (
    <Card className='border-2 border-sky-200 bg-gradient-to-br from-sky-50 via-indigo-50 to-sky-50 shadow-md hover:shadow-lg transition-all duration-300'>
      <CardContent className='p-6'>
        <div className='flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4'>
          <div className='flex-1'>
            <div className='flex items-center gap-2 mb-2'>
              <Users className='h-5 w-5 text-sky-600' />
              <h3 className='text-lg font-semibold text-slate-800'>
                View Player Resource Limits
              </h3>
            </div>
            <p className='text-sm text-slate-600'>
              Monitor current resource usage and limits for all players in this
              room. View individual player configurations and track their
              consumption.
            </p>
          </div>
          <NavLink
            to={ROUTES.PROFESSOR.ROOM_PLAYER_RESOURCE_LIMITS(roomId)}
            className='flex-shrink-0'
          >
            <Button
              variant='outline'
              className='bg-white hover:bg-sky-50 border-sky-300 text-sky-700 hover:text-sky-800 shadow-sm hover:shadow-md transition-all duration-200'
            >
              <Users className='h-4 w-4 mr-2' />
              View Player Limits
            </Button>
          </NavLink>
        </div>
      </CardContent>
    </Card>
  )
}
